interface VideoViewerProps {
	url: string;
	name: string;
}

export function VideoViewer({ url, name }: VideoViewerProps) {
	return (
		<div className="bg-stripes flex h-full items-center justify-center p-6">
			<video
				src={url}
				controls
				controlsList="nodownload"
				aria-label={name}
				className="max-h-full max-w-full rounded-md"
			>
				<track kind="captions" />
			</video>
		</div>
	);
}
